import { useT } from '@repo/ui/hooks'
import { Language } from '@repo/ui/lang'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui/select'

export function LanguageSelector({
  defaultLanguage,
  onSetLanguage,
}: {
  defaultLanguage: Language
  onSetLanguage: (language: Language) => void
}) {
  const { tc } = useT()
  return (
    <Select onValueChange={onSetLanguage} defaultValue={defaultLanguage}>
      <SelectTrigger className="max-w-40">
        <SelectValue placeholder={tc('selectLanguagePlaceholder')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={Language.EN}>
          <div className="flex items-center">English</div>
        </SelectItem>
        <SelectItem value={Language.FR}>
          <div className="flex items-center">Français</div>
        </SelectItem>
        <SelectItem value={Language.ES}>
          <div className="flex items-center">Español</div>
        </SelectItem>
        <SelectItem value={Language.PT}>
          <div className="flex items-center">Português</div>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
